export default {
  'usual-menus.first-nav': '快捷',
  'usual-menus.select-menu': '选择菜单',
  'usual-menus.select-menu.placeholder': '输入关键字进行搜索',
  'usual-menus.no-data': '暂无数据',
}
